
<template>
    <label class="custom-checkbox" :class="styleModifier">
        <span
            v-if="displayRadio"
            class="custom-checkbox-indicator"
            :class="{ 'custom-checkbox-indicator_active': value, 'no-shadow': noShadow }"
        ></span>
        <input v-if="displayRadio" :value="val" type="checkbox" name="" v-model="model" required />
        <span v-if="labelHtml" class="custom-checkbox__label" v-html="labelText"></span>
        <span v-else-if="labelText" class="custom-checkbox__label">
            {{ labelText }}
        </span>
    </label>
</template>

<script>
export default {
    name: "CustomCheckbox",
    props: {
        labelText: String,
        value: {
            type: [Boolean, Number],
            default: 1
        },
        labelHtml: {
            type: Boolean,
            default: false
        },
        displayRadio: {
            type: Boolean,
            default: true
        },
        noShadow: {
            type: Boolean,
            default: false
        },
        val: [Boolean, Number],
        styleModifier: Array
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit("input", val)
            }
        }
    }
}
</script>
<style lang="sass">
.custom-checkbox
    cursor: pointer
    display: flex
    .custom-checkbox-indicator
        min-width: 20px
        width: 20px
        height: 20px
        border-radius: 50%
        box-shadow: 2px 2px 10px rgba(128, 158, 191, 0.15)
        background: #DDDDDD
        transition: .3s
        border: 3px solid #fff
        &.no-shadow
            box-shadow: none
        &_active
            background: #30C58F
    input[type="checkbox"]
        display: none
    &__label
        color: #52565C
        margin-left: 10px
        font-size: 12px
        line-height: 15.6px
        display: flex
    &__lesson &__label
        font-size: 13px
        line-height: 130%
    &__lesson
        .custom-checkbox-indicator
            border-width: 1px
            border-color: transparent
            position: relative
            background-color: transparent
            &:before, &:after
                content: ""
                position: absolute
                top: 50%
                left: 50%
                border-radius: 50%
                transform: translate(-50%, -50%)
            &:before
                width: 16px
                height: 16px
                border: 1px solid #DDDDDD
            &:after
                width: 10px
                height: 10px
                background-color: #DDDDDD
            &_active
                &:before
                    border-color: #15A06E
                &:after
                    background-color: #15A06E
    &_v2
        .custom-checkbox-indicator
            min-width: 16px
            width: 16px
            height: 16px
            border-radius: 50%
            background: #fff
            border: 1px solid #DDDDDD
            position: relative
            transition: 0s !important
            &::after
                content: ''
                width: 10px
                height: 10px
                top: 2px
                left: 2px
                border-radius: 50%
                background: #DDDDDD
                position: absolute
            &_active
                border-color:  #15A06E
                &::after
                    background: #15A06E
</style>
